import React from "react";
import { merge } from "lodash";
import { connect } from "react-redux";
import { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { Card, Box } from "@mui/material";
import { BaseOptionChart } from "../../charts";
import { createMultilineXAxis, formatMultilineLabel } from "../../../utils/chartUtils";

const DiseaseBarChart = (props) => {
  const chartOptions = merge(BaseOptionChart(), {
    chart: {
      type: "bar",
      toolbar: { show: false }
    },
    grid: {
      borderColor: "transparent",
      row: {
        colors: ["transparent"],
        opacity: 0.5
      }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "45%",
        borderRadius: 6,
        distributed: false,
        dataLabels: {
          position: "top", // Put labels on top
        }
      }
    },
    dataLabels: {
      enabled: true,
      offsetY: -20, // Move label upward (adjust as needed)
      style: {
        colors: ["#8e8e8e"]
      },
      formatter: (val) => val
    },
    xaxis: {
      categories: props.icpc_consultation.icpc_descriptions,
      labels: {
        maxHeight: 80,
        formatter: function(value) {
          return formatMultilineLabel(value);
        },
        style: {
          fontSize: "12px",
          fontWeight: "bold",
          colors: "#1F4E79"
        }
      },
    },
    yaxis: {
      show: false
    },
    legend: {
      show: false
    },
    tooltip: {
      enabled: false
    },
    colors: [
      "#3D718E", "#FFD700", "#3498DB", "#8E44AD", "#1ABC9C", 
      "#E74C3C", "#3D718E", "#FFD700", "#3498DB", "#8E44AD"
    ] // Manually set colors to match image
  });

  const chartSeries = [
    {
      data: props.icpc_consultation.icpc_counts
    }
  ];

  return (
    <Card sx={{ boxShadow: "none", mt: 4, p: 2, width: "100%" }}>
      <Box sx={{ width: "100%" }}>
        <ReactApexChart
          type="bar"
          series={chartSeries}
          options={chartOptions}
          height={350}
        />
      </Box>
    </Card>
  );
};

const mapState = state => ({
  icpc_consultation: state.overview.icpc_consultation
});

const mapDispatch = ({
  overview: { loadData }
}) => ({
  loadData: () => loadData()
});

export default connect(mapState, mapDispatch)(DiseaseBarChart);
